import { Market } from '@shared/config/market/market.models';
import { semboAssets } from '@shared/config/market/market.assets';
import {
    OUR_POLICIES_PATH,
    TRAVEL_CONDITIONS_PATH,
} from '@shared/config/market/data/market.data.consts';

export const dtfDanishCompanyData: Market = {
    number: 405,
    domain: 'sembo.dk',
    isSubdomain: false,
    locale: 'da',
    fullLocale: 'da-DK',
    name: 'Sembo - tidligere DTF Travel',
    homePage: 'https://www.sembo.dk',
    copyright: 'Stena Line Travel Group AB',
    assets: semboAssets,
    links: {
        newsletter: 'https://www.sembo.dk/bestil-og-download/nyhedsbrev/',
    },
    footerInfo: [
        [
            {
                text: 'Kungsgatan 6, 252 21 Helsingborg, SVERIGE',
            },
            {
                text: 'Registreringsnummer: 556529-1795',
            },
            {
                text: 'Registreret kontor: Helsingborg, Sverige',
            },
        ],
        [
            {
                text: 'Privatlivspolitik',
                href: OUR_POLICIES_PATH,
            },
            {
                text: `Sembo Rejsebetingelser`,
                href: TRAVEL_CONDITIONS_PATH,
            },
            {
                text: 'Arbejde hos Sembo',
                href: 'https://career.sembo.com/',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 0,
        decimalSeparator: ',',
        currency: 'DKK',
        currencySymbol: 'kr',
    },
};
